import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { Warning } from "@mui/icons-material";

const MicrophonePermissionPopup = ({ open, onClose, onRequestPermission }) => {
  const handleRequestPermission = async () => {
    try {
      // Request microphone permission
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // If successful, stop the stream and close the popup
      stream.getTracks().forEach(track => track.stop());
      onClose();
    } catch (error) {
      console.error("Error requesting microphone permission:", error);
      // The popup will remain open if permission is still denied
      if (onRequestPermission) {
        onRequestPermission(error);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Warning color="warning" fontSize="large" />
          <Typography variant="h6" component="div">
            Microphone Permission Required
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          This application requires microphone access to enable voice recording for the simulation.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Please grant microphone permission to continue. You can do this by:
        </Typography>
        <Box component="ul" sx={{ pl: 3, mb: 2 }}>
          <Typography component="li" variant="body2" paragraph>
            Click the lock icon in your browser's address bar
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            Select "Allow" for microphone permissions
          </Typography>
          <Typography component="li" variant="body2" paragraph>
            Refresh the page after granting permission
          </Typography>
        </Box>
        <Typography variant="body2" color="error">
          Note: If you've previously denied permission, you may need to reset it in your browser settings.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        {/* <Button
          onClick={handleRequestPermission}
          variant="contained"
          color="primary"
          autoFocus
        >
          Request Permission
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default MicrophonePermissionPopup;

